export default __webpack_public_path__ + "static/media/code.80e1ed2c.png";